import { apiClient } from '@/shared/services/client'
import type {
  ReporteCliente,
  PaginatedReportesCliente,
  ReporteClienteCreateInput,
  ReporteClienteUpdateInput,
  CategoriaReporte,
  GrupoDisponible,
} from '../types'

const BASE_URL = '/cemc'

export const clientesApi = {
  getReportes: async (params?: {
    page?: number
    page_size?: number
    search?: string
    grupo_id?: number
    categoria?: string
    activo?: boolean
  }): Promise<PaginatedReportesCliente> => {
    const { data } = await apiClient.get(`${BASE_URL}/reportes/`, { params })
    return data
  },

  getReporte: async (id: number): Promise<ReporteCliente> => {
    const { data } = await apiClient.get(`${BASE_URL}/reportes/${id}/`)
    return data
  },

  createReporte: async (payload: ReporteClienteCreateInput): Promise<ReporteCliente> => {
    const { data } = await apiClient.post(`${BASE_URL}/reportes/`, payload)
    return data
  },

  updateReporte: async (id: number, payload: ReporteClienteUpdateInput): Promise<ReporteCliente> => {
    const { data } = await apiClient.put(`${BASE_URL}/reportes/${id}/`, payload)
    return data
  },

  deleteReporte: async (id: number): Promise<{ message: string; success: boolean }> => {
    const { data } = await apiClient.delete(`${BASE_URL}/reportes/${id}/`)
    return data
  },

  toggleActivo: async (id: number): Promise<ReporteCliente> => {
    const { data } = await apiClient.post(`${BASE_URL}/reportes/${id}/toggle-activo/`)
    return data
  },

  getCategorias: async (): Promise<CategoriaReporte[]> => {
    const { data } = await apiClient.get(`${BASE_URL}/categorias/`)
    return data
  },

  getGruposDisponibles: async (): Promise<GrupoDisponible[]> => {
    const { data } = await apiClient.get(`${BASE_URL}/grupos-disponibles/`)
    return data
  },
}
